export const TableColumn = [     
    { data: 'CompanyId', Title: '#', width: 20, position: 1 },
    { data: 'CompanyName', Title: 'Company Name', position: 2 },
    { data: 'CompanyCode', Title: 'Company Code', position: 3 },
    { data: 'CompanyType.CompanyTypeName', Title: 'Company Type', position: 4 },
    { data: 'CreatedBy.CreatedDate', Title: 'Created Date', position: 5 },
    { data: '', Title: 'Action', position: 6 }
];
